module.exports = __webpack_public_path__ + "img/PPV-Insight.2db9b753.png";